// @flow

import IframeChallenge from './IframeChallenge';
import isSamsungBuiltinBrowser from '../../../lib/isSamsungBuiltinBrowser';
import replaceVASTMacros from '../../../lib/replaceVASTMacros';
import { track } from '../../../lib/track.jsx';

class GoogleIMAChallenge extends IframeChallenge {
    static disablesSupportButton() {
        return true;
    }

    static isSupportedOnCurrentPlatform() {
        return !isSamsungBuiltinBrowser();
    }

    static shouldShowSkipButtonOnStart() {
        return false;
    }

    urlWithReplacedMacros() {
        const challenge = this.props.challenge;
        const url = challenge.adTagUrl;
        if (!challenge || typeof url !== 'string') return null;
        const queryParams = Object.assign(
            {},
            this.props.params.queryParams,
            {
                app_domain: this.props.publisherAppDomainName,
                app_name: this.props.publisherAppName,
            },
        );
        return replaceVASTMacros(url, queryParams);
    }

    isInTestMode() {
        if (!this.props.challenge) return false;
        return !!this.props.challenge.testMode;
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.isInTestMode()) {
            track('AdRequestForDebugging', Object.assign({}, this.props.challenge, {
                adTagUrlAfterReplacing: this.urlWithReplacedMacros(),
            }));
        }
    }

    iFrameSource() {
        const url = this.urlWithReplacedMacros();
        if (!url) return null;
        if (!this.props.challenge) return null;
        if (this.isInTestMode()) return url;
        return `/ima.html?adTagUrl=${encodeURIComponent(url)}`;
    }

    eventImpression() {
        super.eventImpression();
        this.trackImpression(() => {});
        this.trackAdOpportunity(true);
    }

    eventPassback() {
        super.eventPassback();
        this.trackAdOpportunity(false);
    }
}

export default GoogleIMAChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/GoogleIMAChallenge.jsx